export const totalService = {
    methods: {
        totalProductFee(order){
            let total = 0.0;
            if (order && order.orderProducts) {
                order.orderProducts.forEach((product) => {
                    total += product?.fee?.amount ? product?.fee?.amount : 0
                })
            }
            return total
        },

        totalFee(order){
            let total = this.totalProductFee(order)
            if (order && order.nonProductFees) {
                order.nonProductFees.forEach((fee) => {
                    total += fee?.amount ? fee?.amount : 0
                })
                return total
            }
            return null
        },
    }
}